'use strict'

import React from 'react'
import PropTypes from 'prop-types'

/**
 * 参照可否アイコン（参照可/参照不可の状態を表示）
 *
 * @param {boolean} referable - 参照可能かどうか
 * @param {number} notConfiguredCount - 未設定/不要項目数
 */
function ReferableIcon({ referable, notConfiguredCount }) {
  const title = referable ? '参照可' : `参照不可（未設定/不要 ${notConfiguredCount ?? 0} 件）`
  const circleClass = referable
    ? 'matrix-referable-icon__circle bg-green-100 border border-green-300 text-green-600'
    : 'matrix-referable-icon__circle bg-red-100 border border-red-300 text-red-600'
  return (
    <span className="matrix-referable-icon" title={title}>
      <span className={circleClass}>
        {referable ? (
          <svg
            width="9"
            height="9"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 7l3 3 5-6" />
          </svg>
        ) : (
          <svg
            width="8"
            height="8"
            viewBox="0 0 12 12"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <path d="M2 2l8 8M10 2L2 10" />
          </svg>
        )}
      </span>
      {!referable && (notConfiguredCount ?? 0) > 0 && (
        <span className="matrix-referable-icon__badge">{notConfiguredCount}</span>
      )}
    </span>
  )
}

ReferableIcon.propTypes = {
  referable: PropTypes.bool.isRequired,
  notConfiguredCount: PropTypes.number
}

ReferableIcon.defaultProps = {
  notConfiguredCount: 0
}

// 参照列は行数分描画されるため、props（referable/notConfiguredCount）が変わらない限り再レンダーしない。
export default React.memo(ReferableIcon)
